var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 22.375,
    width: 12.25,
    height: 18.25,
    rx: 1.625,
    fill: "#F3F7FF",
    stroke: "#518EF8",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.375,
    y: 22.375,
    width: 24.25,
    height: 18.25,
    rx: 1.625,
    fill: "#F3F7FF",
    stroke: "#518EF8",
    strokeWidth: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 44.375,
    width: 40.25,
    height: 5.25,
    rx: 1.625,
    fill: "#F3F7FF",
    stroke: "#518EF8",
    strokeWidth: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 40.25,
    height: 18.25,
    rx: 1.625,
    fill: "#F3F7FF",
    stroke: "#518EF8",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout2);
export default __webpack_public_path__ + "static/media/Layout 2.b761363e528181e3db71e419650a7583.svg";
export { ForwardRef as ReactComponent };